// Reusable selectors for subscription state
// Makes it easier to access subscription-related state across components

/**
 * Get isFreePlan from subscription state
 */
// In class components - with mapStateToProps
// import { selectIsFreePlan } from '../redux/Profile/subscriptionSelectors';

// const mapStateToProps = (state) => ({
//     isFreePlan: selectIsFreePlan(state),
// });
export const selectIsFreePlan = (state) => state.subscription.isFreePlan;

/**
 * Get isTrialPlan from subscription state
 */
export const selectIsTrialPlan = (state) => state.subscription.isTrialPlan;

/**
 * Get subscriptionData from subscription state
 */
export const selectSubscriptionData = (state) => state.subscription.subscriptionData;

